const io = require('socket.io-client');

const SocketConnection = {

    _socket: null,
    connected: false,
    connecting: false,

    loadMinigameHandler: null,
    startMinigameHandler: null,
    closeMinigameHandler: null,
    hostViewUrlChangeHandler: null,

    konamiLoseHandler: null,

    connect: (playerNum) => {

        console.log(`SocketConnection: connect() was called.`);

        SocketConnection.connecting = true;
        if (SocketConnection._socket) {
            SocketConnection._socket.disconnect();
            SocketConnection._socket = null;
        }
        
        // testing on local machine:
        // SocketConnection._socket = io.connect("https://127.0.0.1:9000", { secure: true, rejectUnauthorized: false });

        // live
        SocketConnection._socket = io.connect("https://play.livescape.tv:9000", { secure: true, rejectUnauthorized: false });

        SocketConnection._socket.on('connect', () => {
            SocketConnection.connecting = false;
            SocketConnection.connected = true;
            SocketConnection._socket.emit('player', playerNum);
        });

        SocketConnection._socket.on('disconnect', () => {
            SocketConnection.connected = false;
            SocketConnection.connecting = true;
        });

        if (playerNum === 'host') {
            console.log(`You are the host.`);
        } else {
            SocketConnection._socket.on('load_minigame', (name) => {
                console.log(`Asked to load mini game: `, name);
                SocketConnection.closeMinigameHandler();
                SocketConnection.loadMinigameHandler(name);
            });
    
            SocketConnection._socket.on('start_minigame', SocketConnection.startMinigameHandler);
            SocketConnection._socket.on('close_minigame', SocketConnection.closeMinigameHandler);
            // SocketConnection._socket.on('hostview_url', SocketConnection.hostViewUrlChangeHandler);
            // SocketConnection._socket.on('konami_lose', SocketConnection.konamiLoseHandler);

            SocketConnection._socket.on('hostview_url', (url) => {
                SocketConnection.hostViewUrlChangeHandler(url);
            });

            SocketConnection._socket.on('konami_lose', () => {
                SocketConnection.konamiLoseHandler();
            });
        }
    },


    test: () => {
        console.log('SOCKET TEST');
    },


    /**
     * Player view functions
     */
    sendButtonPress: () => {
        SocketConnection._socket.emit("button");
    },

    sendKonamiWin: () => {
        SocketConnection._socket.emit('konami_win');
    },


    /**
     * Host view functions
     */
    startMinigame: (name) => {
        SocketConnection._socket.emit('start_minigame', name);
    },

    closeMinigame: () => {
        SocketConnection._socket.emit('close_minigame');
    },

    setHostViewUrl: (url) => {
        SocketConnection._socket.emit('hostview_url', url);
    },

};

export default SocketConnection;
